<template>
  <div class="home-page">
    <div class="home-page-inner">
      <div class="home-page-content">
        <h2>WELCOME</h2>
        <p>欢迎进入工程设备招采系统</p>
        <span>请点击左侧导航，选择你想查看的内容</span>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {};
		}
	};
</script>

<style lang="scss" scoped>
  .home-page {
    position: relative;
    height: 100%;
    min-height: 100%;
    padding-top: 48px;
  }
  .home-page-inner {
    height: 100%;
    display: flex;
    background: url("../../common/images/login_bg_1366.png") no-repeat center
    center;
    background-size: 100% 100%;
  }
  .home-page-content {
    position: relative;
    z-index: 3;
    text-align: center;
    line-height: 1.4;
    margin: auto;
    >h2{
      color:#E4E6EB;
      font-size: 40px;
    }
    >p{
      color:#3A9D81;
      font-size: 30px;
      font-weight: 800;
      margin-top: 10px;
      margin-bottom: 18px;
    }
    >span{
      color:#666;
    }
  }
  /**
    用于css媒体查询设置
    */

  @media screen and (max-width: 1900px) {
    .no-permission-box {
      background-image: url(../../common/images/login_bg.png);
    }
  }
  @media screen and (max-width: 1600px) {
    .no-permission-box {
      background-image: url(../../common/images/login_bg_1366.png);
    }
  }
</style>
